import React, { useState, useEffect, useMemo } from "react"
import lodash from "lodash"

import { useField } from '../../../../1stlog-ui/src/components/Field'

const useFilledOrErrorField = name => {
  const {
    meta: { error },
    input: { value }
  } = useField(name, { raw: true, subscription: { value: true, error: true } })

  return (value && value !== "") || error
}

export default useFilledOrErrorField
